import { useSiteData } from "@/context/SiteDataContext";
import { resolveSiteText, type SiteTextKey } from "@/lib/siteTexts";

export type TFunction = (key: SiteTextKey, vars?: Record<string, string | number>) => string;

// Devuelve el texto editado desde el admin (Textos del sitio) o, si no se ha editado, el original.
export function useT(): TFunction {
  const { data } = useSiteData();
  const overrides = data.contentBlocks.textos?.site?.[0]?.values;
  return (key, vars) => resolveSiteText(overrides, key, vars);
}
